import React from 'react'
import { BiSearch } from "react-icons/bi";

const FarmSearchBox = ({ handleChange }) => {
    return (
        <div className="farm-search-bar">
            <BiSearch className="farm-search-icon" />
            <input className="farm-search-input" type="search" placeholder="Search Pool" onChange={ handleChange } />
        </div>
    );
}

export default FarmSearchBox;
